"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../utils");

var _PurchaseMotionPropsInterface = require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionPropsInterface");

var _purchaseMotions = require("ui-addon-upgrades/_core/common/constants/purchaseMotions");

var PurchaseMotionButton = function PurchaseMotionButton(props) {
  var merchandiseId = props.merchandiseId,
      trackingSource = props.trackingSource,
      purchaseMotions = props.purchaseMotions,
      level = props.level;
  var purchaseMotion = purchaseMotions[level - 1];
  var mappedButtonPassthroughProps = props.passthroughProps[purchaseMotion] || {};
  var mappedButtonPropsInterface = _purchaseMotions.purchaseMotionButtonPropsInterface[purchaseMotion];
  var MappedButtonComponent = props.overrides[purchaseMotion] || _purchaseMotions.purchaseMotionButtons[purchaseMotion];

  if ((0, _utils.isUndefined)(MappedButtonComponent) || (0, _utils.isUndefined)(mappedButtonPropsInterface)) {
    return null;
  }

  var propsToKeep = [].concat((0, _toConsumableArray2.default)(Object.keys(mappedButtonPropsInterface)), ['upgradeData']);
  var propsToOmit = Object.keys((0, _utils.omit)(_PurchaseMotionPropsInterface.PurchaseMotionButtonPropsInterface, propsToKeep));
  var propsToPass = (0, _utils.omit)(props, propsToOmit);
  return _react.default.createElement(MappedButtonComponent, (0, _extends2.default)({
    "data-selenium-id": trackingSource + "-" + merchandiseId + "-" + purchaseMotion + "-button",
    "data-reagan-primary-cta": true,
    truncate: true
  }, mappedButtonPassthroughProps, propsToPass));
};

PurchaseMotionButton.defaultProps = {
  overrides: {},
  passthroughProps: _purchaseMotions.purchaseMotionKeys.reduce(function (accumulator, key) {
    accumulator[key] = {};
    return accumulator;
  }, {})
};
PurchaseMotionButton.propTypes = _PurchaseMotionPropsInterface.PurchaseMotionButtonPropsInterface;
var _default = PurchaseMotionButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/purchaseMotions/PurchaseMotionButton.js
// module id = 501
// module chunks = 5 6